<template>
  <v-row class="justify-center mt-2">
    <v-card elevation="10" class="card">
      <div class="headerCard">
        <v-icon size="30">mdi-form-textbox</v-icon>
        <label class="labels">{{ $t('sales.affiliates_program_publish_basic_info') }}</label>
      </div>
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          height: 50%;
        "
      >
        <p style="font-size: 20px">{{ dataProgram.name }}</p>
        <small>{{ dataProgram.slug }}</small>
      </div>
    </v-card>

    <v-card elevation="10" class="card">
      <div class="headerCard">
        <v-icon size="30">mdi-cash-multiple</v-icon>
        <label class="labels">{{ $t('sales.affiliates_program_commissioning') }}</label>
      </div>
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          height: 50%;
        "
        v-if="dataProgram.taxCommission !== null"
      >
        <p style="font-size: 45px; font-weight: bold">
          {{ dataProgram.taxCommission }}
        </p>
      </div>
      <div
        v-else
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          height: 50%;
          text-align: center;
        "
      >
        <p>{{ $t('sales.affiliates_program_no_commissioning') }}</p>
      </div>
    </v-card>

    <v-card elevation="10" class="card">
      <div class="headerCard">
        <v-icon size="30">mdi-alert-circle-check-outline</v-icon>
        <label class="labels">{{ $t('sales.affiliates_program_limits') }}</label>
      </div>
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          height: 50%;
          text-align: center;
        "
      >
        <p class="ellipsis-text">
          {{ descriptionProduct }}
        </p>

        <div style="display: flex; gap: 15px; width: 100%">
          <div style="width: 50%">
            <div v-if="!hasProductVariations">
              <p style="font-size: 12px">{{ $t('sales.affiliates_program_tickets_field') }}</p>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <p
                    v-bind="attrs"
                    v-on="on"
                    style="font-size: 20px; font-weight: bold"
                  >
                    {{ vatiationsQuantity }}
                  </p>
                </template>
                <span>
                  <v-col v-for="(variation, i) in selectedVariation" :key="i">
                    {{
                      variation && variation.descricao
                        ? variation.descricao
                        : ""
                    }}
                  </v-col>
                </span>
              </v-tooltip>
            </div>
            <p style="font-size: 12px" v-else>{{ $t('sales.affiliates_program_publish_no_ticket') }}</p>
          </div>
          <v-divider vertical></v-divider>
          <div style="width: 50%">
            <div v-if="hasLimitSales">
              <p style="font-size: 12px">{{ $t('sales.affiliates_program_publish_ticket_limit') }}</p>
              <p style="font-size: 20px; font-weight: bold">
                {{ dataProgram.limit }}
              </p>
            </div>
            <p style="font-size: 12px" v-else>{{ $t('sales.affiliates_program_publish_no_ticket_limit') }}</p>
          </div>
        </div>
      </div>
    </v-card>

    <v-card elevation="10" class="card">
      <div class="headerCard">
        <v-icon size="30">mdi-account-group</v-icon>
        <label class="labels">{{ $t('sales.affiliates') }}</label>
      </div>

      <div
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          height: 50%;
        "
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <p
              v-bind="attrs"
              v-on="on"
              style="font-size: 45px; font-weight: bold"
            >
              {{ affiliatesQuantity }}
            </p>
          </template>
          <span>
            <v-col
              v-for="affiliate in dataProgram.affiliates"
              :key="affiliate.email"
            >
              {{ affiliate.nome }}
            </v-col>
          </span>
        </v-tooltip>
      </div>
    </v-card>

    <v-card elevation="10" class="card">
      <div class="headerCard">
        <v-icon size="30">mdi-sale</v-icon>
        <label class="labels">{{ $t('sales.affiliates_program_one_discount') }}</label>
      </div>
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          height: 50%;
        "
        v-if="
          dataProgram.valueDiscount !== null ||
          dataProgram.percDiscount !== null
        "
      >
        <p
          v-if="dataProgram.percDiscount !== null"
          style="font-size: 45px; font-weight: bold"
        >
          {{ dataProgram.percDiscount }}
        </p>
        <p
          v-if="dataProgram.valueDiscount !== null"
          style="font-size: 45px; font-weight: bold"
        >
          {{ dataProgram.valueDiscount }}
        </p>
        <small style="text-align: center"
          >{{ $t('sales.affiliates_program_publish_discount_info') }}</small
        >
      </div>
      <div
        v-else
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          height: 50%;
          text-align: center;
        "
      >
        <p>{{ $t('sales.affiliates_program_publish_no_discount_info') }}</p>
      </div>
    </v-card>
    <v-col cols="12"
      ><v-btn
        class="btn-color"
        :color="$config.dados.corinputs"
        style="color: white"
        @click="handleSubmitForm"
      >
        {{ $t('sales.affiliates_program_publish_invite') }}
      </v-btn>
      <v-btn text> {{ $t('sales.affiliates_program_save_draft') }} </v-btn>
      <v-btn text @click="stepBackProgram()"> {{ $t('sales.affiliates_program_return') }} </v-btn></v-col
    >
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Publish",
  computed: {
    ...mapGetters(["dataProgram"]),
    affiliatesQuantity() {
      return this.dataProgram?.emails?.length;
    },
    hasProductVariations() {
      return (
        this.dataProgram?.product?.variantes?.variacoes_produto?.length === 0 ||
        this.dataProgram?.product?.variantes?.variacoes_produto === null
      );
    },
    hasLimitSales() {
      return (
        this.dataProgram?.limit !== null &&
        this.dataProgram?.limit !== 0 &&
        this.dataProgram?.limit !== undefined
      );
    },
    vatiationsQuantity() {
      return this.dataProgram?.products?.length;
    },
    selectedVariation() {
      if (this.dataProgram?.products?.length === 0) return;
      return this.dataProgram?.products?.map(variation => {
        return this.dataProgram?.product?.variantes?.variacoes_produto?.find(
          variante => variante?.idproduto_variacao === variation
        );
      });
    },
    descriptionProduct() {
      return this.dataProgram?.product?.descricao;
    },
  },
  methods: {
    ...mapActions([
      "stepBackProgram",
      "createAffiliateProgram",
      "showSnackbarSuccess",
      "cleanStates",
    ]),
    handleSubmitForm() {
      const formData = {
        nome: this.dataProgram.name,
        slug: this.dataProgram.slug,
        taxa_comissao:
          parseFloat(
            this.dataProgram?.taxCommission
              ?.replace(/[^\d.,]/g, "")
              ?.replace(",", ".")
          ) || 0,
        valor_desconto:
          parseFloat(
            this.dataProgram?.valueDiscount
              ?.replace(/[^\d.,]/g, "")
              ?.replace(",", ".")
          ) || 0,
        perc_desconto:
          parseFloat(this.dataProgram?.percDiscount?.replace(/[^\d.,]/g, "")) ||
          0,
        tipo_comissao: this.dataProgram.typeCommission,
        limite: +this.dataProgram.limit || 0,
        emails: this.dataProgram.emails,
        idproduto: this.dataProgram.product.idproduto,
        nidproduto_variacao: this.dataProgram.products,
        status: "ATIVO",
      };
      this.createAffiliateProgram(formData).then(() => {
        this.showSnackbarSuccess(this.$t('sales.affiliates_program_save_success'));
        this.$router.push("/programa-afiliados");
        this.cleanStates();
      });
    },
  },
};
</script>

<style scoped>
.card {
  padding: 20px;
  border-radius: 10px;
  margin: 12px;
  min-height: 200px;
  width: 280px;
}
.labels {
  font-size: 16px;
  font-weight: 800;
  margin-left: 10px;
}
.headerCard {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}
.ellipsis-text {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  margin-bottom: 12px !important;
  width: 250px;
}
</style>
